import React, { Suspense } from 'react';
import Navbar from './Dashboard/Pages/Navbar';
import Footer from './Dashboard/Pages/Footer';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import SEO from './components/SEO'

// Every page-level route is code-split so a visit to any one page only
// downloads that page's own code (plus its share of common chunks) instead
// of the whole site's — Navbar/Footer/SEO stay eager since they render on
// every page regardless of route.
const Hero = React.lazy(() => import('./Dashboard/Pages/heroComponents/Hero'));
const About = React.lazy(() => import('./Dashboard/Pages/About'));
const Agent = React.lazy(() => import('./Dashboard/Pages/agentPlatformComponents/Agent'));
const ProductPage = React.lazy(() => import('./Dashboard/Pages/Product'));
const Blog = React.lazy(() => import('./Dashboard/Pages/Blog'));
const BlogPostPage = React.lazy(() => import('./Dashboard/Pages/BlogPostPage'));
const CaresnippetPage = React.lazy(() => import('./Dashboard/Product/Carepage'));
const GenRxPage = React.lazy(() => import('./Dashboard/Product/Genrxpage'));
const AgentRxPage = React.lazy(() => import('./Dashboard/Product/Agent_Rx_Page'));
const Carerlab = React.lazy(() => import('./Dashboard/Product/Carelab'));
const CarerRx = React.lazy(() => import('./Dashboard/Product/carer_Rx'));
const CarerVoiz = React.lazy(() => import('./Dashboard/Product/CarerVoiz'));
const CarerEHR = React.lazy(() => import('./Dashboard/Product/CarerEHR'));
const CarerKMS = React.lazy(() => import('./Dashboard/Product/CarerKMS'));
const CarerOS = React.lazy(() => import('./Dashboard/Product/CarerOS'));
const Hospilot = React.lazy(() => import('./Dashboard/Product/Hospilot'));
const PublicHealth = React.lazy(() => import('./Dashboard/Product/PublicHealth'));
const Careers = React.lazy(() => import('./Dashboard/Pages/Careers'));
const Press = React.lazy(() => import('./Dashboard/Pages/Press'));
const Partners = React.lazy(() => import('./Dashboard/Pages/Partners'));
const VerticalPage = React.lazy(() => import('./Dashboard/Pages/VerticalPage'));
const PayerJourneyPage = React.lazy(() => import('./Dashboard/Pages/PayerJourneyPage'));
const ProviderJourneyPage = React.lazy(() => import('./Dashboard/Pages/ProviderJourneyPage'));
const PharmaJourneyPage = React.lazy(() => import('./Dashboard/Pages/PharmaJourneyPage'));
const AgentPage = React.lazy(() => import('./Dashboard/Pages/AgentPage'));
const AgentsPage = React.lazy(() => import('./Dashboard/Pages/AgentsPage'));

const App: React.FC = () => {
  return (

    <>
      {/* Site-wide fallback — rendered before the routed pages, so any
          page-specific <SEO> further down the tree overrides these tags. */}
      <SEO
        title="Carer.ai - Smarter Healthcare"
        description="Carer.ai helps patients and doctors connect seamlessly with AI-powered tools."
        path="/"
      />
      <ScrollToTop />
      <Navbar />
      <div className="min-h-screen">
        <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/platform" element={<Agent />} />
            <Route path="/resources" element={<Blog />} />
            <Route path="/resources/:slug" element={<BlogPostPage />} />
            <Route path="/product/caresnippet" element={<CaresnippetPage />} />
            <Route path="/product/voiz" element={<CarerVoiz />} />
            <Route path="/product/ehr" element={<CarerEHR />} />
            <Route path="/product/kms" element={<CarerKMS />} />
            <Route path="/product/os" element={<CarerOS />} />
            <Route path="/hospilot" element={<Hospilot />} />
            <Route path="/product/publichealth" element={<PublicHealth />} />
            {/* <Route path="/product/nurse" element={<Nurse />} /> */}
            {/* <Route path="/product/labtechs" element={<LabTechs />} /> */}
            <Route path="/product/genrx" element={<GenRxPage />} />
            <Route path="/product/agentrx" element={<AgentRxPage />} />
            <Route path="/product/carerlab" element={<Carerlab />} />
            <Route path="/product/carerrx" element={<CarerRx />} />
            <Route path="/verticals/provider" element={<ProviderJourneyPage />} />
            <Route path="/verticals/pharma" element={<PharmaJourneyPage />} />
            <Route path="/verticals/payer" element={<PayerJourneyPage />} />
            <Route path="/verticals/:id" element={<VerticalPage />} />
            <Route path="/agents" element={<AgentsPage />} />
            <Route path="/agents/:slug" element={<AgentPage />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/press" element={<Press />} />
            <Route path="/partners" element={<Partners />} />
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </>
  );
}

export default App;
